export class AutoEmailRule {
  id: number;
  intranet_id: number;
  matter_id: number;
  matter_user_type_id: number | undefined;
  created_by: any;
  updated_by: any;
  created_at: any;
  updated_at: any;
  minimum_priority: number = 10;
  matter_user_type_name: string;
  document_types_str: string;
  matter_full_name: string;
  document_type_ids: Array<number> = [];
  send_to_users_included_in_all_notifications: boolean = false;
}
